export const NFT2023ID = 1122487441;
export const NFT2024ID = 1937292495;
export const NFT2025ID = 3061343167;